import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { tap } from "rxjs";
import { UserService } from "../user/user.service";
import { environment } from "../../../environments/environment";
import { TokenService } from "../token/token.service";

const API = environment.apiUrl;

@Injectable({ providedIn: 'root' })
export class AuthService {

  constructor(private http: HttpClient,
    private tokenService: TokenService,
    private userService: UserService) {

  }

  authenticate(userName: string, password: string, domain: string) {
    return this.http
      .post(
        API + '/v1/security/login',
        { NomeUsuario: userName, Senha: password },
        { observe: 'response' }
      )
      .pipe(tap(res => {
        const authToken = res.body as any;
        this.userService.setToken(authToken.accessToken, authToken.refreshToken);
        console.log(res.headers.get('Baerer'));
        console.log(`User ${userName} authenticated with token ${authToken.accessToken}`);
      }))
  }
  exchangeAuthorizationCode(code: string, state: string | null) {
    return this.http.post(`${API}/v1/security/exchange-code`,
      { Code: code, State: state },
      { observe: 'response' }
    )
      .pipe(tap(res => {
        const authToken = res.body as any;
        this.userService.setToken(authToken.accessToken, authToken.refreshToken);
        console.log(res.headers.get('Baerer'));
        console.log(`User authenticated with token authorization code`);
      })

      );
  }

  logout() {
    const refreshToken = this.tokenService.getRefreshToken();

    if (refreshToken) {
      this.http.post(API + '/v1/security/logout', { refreshToken }).subscribe({
        next: () => this.userService.logout(),
        error: () => this.userService.logout() // mesmo com erro, limpa o local
      });
    } else {
      this.userService.logout();
    }
  }


}
